import {Component, effect, EventEmitter, inject, input, Input, Output, signal} from '@angular/core';
import {LessonFacetsService} from '@modules/activities/core/lesson-facets/lesson-facets.service';
import {LessonFacetItem} from '@modules/activities/core/lesson-facets/models';
import {EducationalLevelEntity} from '@modules/activities/core/services/educational-level.service';
import {take} from 'rxjs/operators';
import {AutoUnsubscribeTakeUntilClass, ConceptEntity} from 'shared/models';
import {Filter} from '@modules/activities/core/activities-search-engine/filter-selector/filter';

@Component({
    selector: 'app-educational-level-filter-selector-of-concepts-list',
    templateUrl: './educational-level-filter-selector-of-concepts-list.component.html',
    styleUrls: ['./educational-level-filter-selector-of-concepts-list.component.scss'],
    standalone: false
})
export class EducationalLevelFilterSelectorOfConceptsListComponent extends AutoUnsubscribeTakeUntilClass {

    @Output() public educationalLevelSelected = new EventEmitter<LessonFacetItem>();
    public conceptList = input.required<ConceptEntity[]>();

    public isLoading = signal(true);
    public availableEducationalLevelsToFilters = signal<Filter<LessonFacetItem>[]>([]);

    private lessonFacetsService = inject(LessonFacetsService)

    constructor() {
        super();

        effect(async () => {
            this.availableEducationalLevelsToFilters.set([]);
            this.isLoading.set(true);

            if (!this.conceptList() || this.conceptList().length === 0) {
                this.isLoading.set(false);
                return;
            }

            const conceptId = this.conceptList()[0]?.id;
            this.lessonFacetsService.getLessonFacets({
                filters: {concept: +conceptId},
            }).pipe(
                take(1)
            ).subscribe(lessonFacetsDataEntity => {
                const availableLevelsForConcepts = lessonFacetsDataEntity.attributes.levels
                const levelsAsFilters = availableLevelsForConcepts.map((educationalLevel) => ({
                        label: educationalLevel.name,
                        id: educationalLevel.id,
                        icon: 'add',
                        type: 'educationalLevel',
                        originalResource: educationalLevel
                }))
                this.availableEducationalLevelsToFilters.set(levelsAsFilters);
                this.isLoading.set(false);
            })
        }, {
            allowSignalWrites: true
        })
    }

    public onEducationalFilterSelected($event: Filter<LessonFacetItem>): void {
        this.educationalLevelSelected.emit($event.originalResource);
    }

}
